import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDatepicker, MatCalendar } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
import { TimePickerService } from './time-picker-service';

@Component({
    selector: 'app-time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['./time-picker.component.scss'],
    standalone: false
})
export class TimePickerComponent<D=Date> implements OnInit {
  private destroyed = new Subject<void>();
  activeDate: D;
  defaultTime: string;
  today = new Date();
  maxDateTime: string;
  todayDate: boolean;
  selectedDate: D;
  constructor(
    public datePicker: MatDatepicker<D>,
    private readonly dateAdapter: DateAdapter<D>,
    private readonly cdr: ChangeDetectorRef,
    private readonly timeService: TimePickerService,
    private readonly calendar: MatCalendar<D>) {
    this.calendar.stateChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe(() => this.cdr.markForCheck());
  }

  ngOnInit() {
    this.defaultTime = moment(this.selectedDate).format('hh:mm A');
    if (this.timeService.getIsTimeMax()) {
      this.todayDate = true;
      this.maxDateTime = `${this.today.getHours()}:${this.today.getMinutes()}`;
      this.timeService.getSelectedTimeDate().subscribe((date) => {
        const selectedDate = moment(this.selectedDate).startOf('day').toDate();
        const currentDate = moment().startOf('day').toDate();
        if (selectedDate.toDateString() === currentDate.toDateString())
          {this.todayDate = true;}
        else
          {this.todayDate = false;}
      })

    }
  }

  timeChanged($event) {
    this.defaultTime = $event;
    this.selectedDate = this.getSelectedDate($event);
    this.timeService.setSelectedTimeDate(this.selectedDate);
  }

  closeDatepicker() {
    this.selectedDate = this.getSelectedDate(this.defaultTime);
    this.timeService.setSelectedTimeDate(this.selectedDate);
    this.datePicker.close();
  }

  private getSelectedDate(time: string):D {
    const twentyfourhour = moment(time, ['h:mm A']).format('HH:mm');
    const splitdateformat = twentyfourhour.split(':');
    const selectedDateRoundOff = this.dateAdapter.deserialize(moment(this.selectedDate).startOf('day').toDate());
    return this.dateAdapter.deserialize(moment(selectedDateRoundOff).add(splitdateformat[0], 'hour')
      .add(splitdateformat[1], 'minute').toDate());
  }
}
